import * as yup from "yup";

import { other } from "../constants/formClaimValidation";

export const formClaimValidationSchema = yup.object().shape({
  predefinedOwnerName: yup
    .string()
    .nullable()
    .required("This field is required."),
  customOwnerName: yup
    .string()
    .nullable()
    .when("predefinedOwnerName", (predefinedOwnerName, schema) =>
      predefinedOwnerName === other
        ? schema.required("This field is required.")
        : schema
    )
});
